import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { FinanceEntityIdSchema } from '../finance/finance-entity-id.ts'
import { ProjectIdSchema } from '../unique-id.models.ts'
import { ChargeMethodSchema } from './charge-method.ts'
import { ChargeStatusSchema } from './charge-status.ts'
import { RefundIdSchema } from './refund-id.ts'
import { UnitSchema } from './unit.ts'

export const RefundSchema = z.object({
  refundId: RefundIdSchema,
  status: ChargeStatusSchema,
  financeEntityId: FinanceEntityIdSchema,
  projectId: ProjectIdSchema,
  amount: z.number().nonpositive(),
  unit: UnitSchema,
  billingMethod: ChargeMethodSchema,
  originalAmount: z.number().nonpositive().optional(),
})

export type Refund = ZodInfer<typeof RefundSchema>
